const translation = {
  createMessageTitle: {
    ar: "انشر رسالتك للعالم",
    en: (
      <>
        Share your <br /> message to the world
      </>
    ),
  },
  createMessageFormInputName: {
    ar: "ألأسم",
    en: "Name",
  },
  createMessageFormInputMessage: {
    ar: "رسالة",
    en: "Message",
  },
  createMessageFormFinish: {
    ar: "شكرا للمشاركة, سنقوم بمراجعتها ونشرها",
    en: "Thank you, we will review and share it",
  },
  createMessageFormInfo:{
      ar:'سنقوم بمراجعة الرسالة قبل نشرها',
      en:'We will review before publishing'
  },
  createMessageFormSubmit:{
      ar:'ارسال',
      en:'Submit'
  },
  createMessageFormBack:{
      ar:'رجوع',
      en:'Back'
  }
};

export default translation;
